<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">PPOB Product - Create New</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create PPOB Product</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Type"
            class="required"
            label-for="input-1"
          >
            <b-form-radio-group
              id="type"
              v-model="item.type"
              :options="optionTypes"
              name="type"
              v-validate="'required'"
              data-vv-as="Type"
              class="custom-radio-check"
            ></b-form-radio-group>
            <p style="color:#e74a3b;width:100%;margin-top:.25rem;font-size:80%;">{{ veeErrors.first('type') }}</p>
          </b-form-group>
          <span v-if="item.type === 'other'">
            <input
              v-model="other_type"
              name="other_type"
              id="other_type"
              class="form-control"
              placeholder="Other Type"
            />
          </span>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Bill Type"
            class="required"
            label-for="input-1"
          >
            <b-form-radio-group
              id="bill_type"
              v-model="item.bill_type"
              :options="optionBillTypes"
              name="bill_type"
              v-validate="'required'"
              data-vv-as="Bill Type"
              class="custom-radio-check"
            ></b-form-radio-group>
            <p style="color:#e74a3b;width:100%;margin-top:.25rem;font-size:80%;">{{ veeErrors.first('bill_type') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Brand"
            label-for="input-1"
          >
            <b-form-select
              v-model="item.provider_id"
              name="provider"
              v-validate="'required'"
              data-vv-as="Brand"
              class="form-control"
            >
              <template v-slot:first>
                <option value disabled>-- Brand--</option>
              </template>
              <option
                v-for="data in optionProviders"
                :key="data.id"
                :value="data.id"
              >
                {{ data.gateway }} | {{ data.brand_name }}
              </option>
            </b-form-select>

            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("provider") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Provider Product Code"
            label-class="control-label"
            class="required"
            label-for="provider-product-code"
          >
            <input
              v-model="item.provider_product_code"
              v-validate="'required'"
              name="provider_product_code"
              data-vv-as="Provider Product Code"
              id="provider-product-code"
              class="form-control"
              placeholder="Provider Product Code"
            />
            <b-form-invalid-feedback id="input-provider_product_code-feedback">{{
              veeErrors.first("provider_product_code")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Display Name (English)"
            label-class="control-label"
            class="required"
            label-for="display-name-en"
          >
            <input
              v-model="item.display_name.en"
              v-validate="'required'"
              name="display_name_en"
              data-vv-as="Display Name (English)"
              id="display-name-en"
              class="form-control"
              placeholder="Display Name in English"
            />
            <b-form-invalid-feedback id="input-display_name_en-feedback">{{
              veeErrors.first("display_name_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Display Name (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="display-name-id"
          >
            <input
              v-model="item.display_name.id"
              v-validate="'required'"
              name="display_name_id"
              data-vv-as="Display Name (Bahasa)"
              id="display-name-id"
              class="form-control"
              placeholder="Display Name in Bahasa"
            />
            <b-form-invalid-feedback id="input-display_name_id-feedback">{{
              veeErrors.first("display_name_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (English)"
            label-class="control-label"
            class="required"
            label-for="description-en"
          >
            <input
              v-model="item.description.en"
              v-validate="'required'"
              name="description_en"
              data-vv-as="Description (English)"
              id="description-en"
              class="form-control"
              placeholder="Description in English"
            />
            <b-form-invalid-feedback id="input-description_en-feedback">{{
              veeErrors.first("description_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="description-id"
          >
            <input
              v-model="item.description.id"
              v-validate="'required'"
              name="description_id"
              data-vv-as="Description (Bahasa)"
              id="description-id"
              class="form-control"
              placeholder="Description in Bahasa"
            />
            <b-form-invalid-feedback id="input-description_id-feedback">{{
              veeErrors.first("description_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Base Rate"
            label-class="control-label"
            class="required"
            label-for="base-rate"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-button variant="light" class="custom-input-group-prepend"
                  :class="{
                    'is-invalid': veeErrors.has('base_rate'),
                    'is-valid': $validator.fields.find({ name: 'base_rate' }) &&
                                $validator.fields.find({ name: 'base_rate' }).flags.dirty && 
                                !veeErrors.has('base_rate'),
                    'custom-disabled-color': item.bill_type == 'post_paid'
                  }">
                Rp
                </b-button>
              </b-input-group-prepend>
              <input
                v-model="item.base_rate"
                v-validate="'required|numeric|min_value:50'"
                name="base_rate"
                data-vv-as="Base Rate"
                id="base-rate"
                class="form-control"
                placeholder="Base Rate"
                type="number"
                :disabled="item.bill_type == 'post_paid'"
              />
            </b-input-group>
            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("base_rate") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Publish Rate"
            label-class="control-label"
            class="required"
            label-for="publish-rate"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-button variant="light" class="custom-input-group-prepend"
                  :class="{
                    'is-invalid': veeErrors.has('publish_rate'),
                    'is-valid': $validator.fields.find({ name: 'publish_rate' }) &&
                                $validator.fields.find({ name: 'publish_rate' }).flags.dirty && 
                                !veeErrors.has('publish_rate'),
                    'custom-disabled-color': item.bill_type == 'post_paid'
                  }">
                Rp
                </b-button>
              </b-input-group-prepend>
              <input
                v-model="item.publish_rate"
                v-validate="'required|numeric|min_value:50'"
                name="publish_rate"
                data-vv-as="Publish Rate"
                id="publish-rate"
                class="form-control"
                placeholder="Publish Rate"
                type="number"
                :disabled="item.bill_type == 'post_paid'"
              />
            </b-input-group>
            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("publish_rate") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-checkbox
            id="is_adjustment"
            v-model="item.is_adjustment"
            name="is_adjustment"
          >Set Adjustment</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-show="item.is_adjustment">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Adjustment Type"
            class="required"
            label-for="adjustment-type"
          >
            <b-form-radio-group
              id="adjustment-type"
              v-model="item.adjustment_type"
              :options="optionAdjustmentTypes"
              name="adjustment_type"
              v-validate="item.is_adjustment ? 'required' : ''"
              data-vv-as="Adjustment Type"
              class="custom-radio-check"
            ></b-form-radio-group>
            <p style="color:#e74a3b;width:100%;margin-top:.25rem;font-size:80%;">{{ veeErrors.first('adjustment_type') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-show="item.is_adjustment">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Adjusment Amount"
            label-class="control-label"
            class="required"
            label-for="adjustment-amount"
          >
            <b-input-group>
              <b-input-group-prepend v-if="item.adjustment_type === 'amount'">
                <b-button variant="light" class="custom-input-group-prepend"
                  :class="{
                    'is-invalid': veeErrors.has('adjustment_amount'),
                    'is-valid': $validator.fields.find({ name: 'adjustment_amount' }) &&
                                $validator.fields.find({ name: 'adjustment_amount' }).flags.dirty && 
                                !veeErrors.has('adjustment_amount')
                  }">
                Rp
                </b-button>
              </b-input-group-prepend>
              <input
                v-model="item.adjustment_amount"
                v-validate="item.is_adjustment ? 'required|numeric|min_value:1' : ''"
                name="adjustment_amount"
                data-vv-as="Adjustment Amount"
                id="adjustment-amount"
                class="form-control"
                placeholder="Adjustment Amount"
                type="number"
              />
              <b-input-group-append v-if="item.adjustment_type === 'percentage'">
                <b-button variant="light" class="custom-input-group-append"
                  :class="{
                    'is-invalid': veeErrors.has('adjustment_amount'),
                    'is-valid': $validator.fields.find({ name: 'adjustment_amount' }) &&
                                $validator.fields.find({ name: 'adjustment_amount' }).flags.dirty && 
                                !veeErrors.has('adjustment_amount')
                  }">
                %
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("adjustment_amount") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Adjustment As"
            label-for="input-1"
          >
            <b-form-select
              v-model="item.adjustment_as"
              name="adjustment_as"
              v-validate="item.is_adjustment ? 'required' : ''"
              data-vv-as="Adjustment As"
              class="form-control"
            >
              <template v-slot:first>
                <option value disabled>-- Adjustment As --</option>
              </template>
              <option
                v-for="data in optionAdjustmentAs"
                :key="data.value"
                :value="data.value"
              >
                {{ data.text }}
              </option>
            </b-form-select>

            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("adjustment_as") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-show="item.is_adjustment">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Special Rate"
            label-class="control-label"
            class="required"
            label-for="special-rate"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-button variant="light" class="custom-input-group-prepend custom-disabled-color">Rp</b-button>
              </b-input-group-prepend>
              <input
                v-model="special_rate"
                v-validate="item.is_adjustment ? 'required|numeric|min_value:0' : ''"
                name="special_rate"
                data-vv-as="Special Rate"
                id="special-rate"
                class="form-control"
                placeholder="Special Rate"
                type="number"
                :disabled="true"
              />
            </b-input-group>
            <b-spinner v-if="loading_special_rate" small label="Loading..."></b-spinner>
            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("special_rate") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            id="is_cross_out_publish_rate"
            v-model="item.is_cross_out_publish_rate"
            name="is_cross_out_publish_rate"
            class="mt-4"
            :disabled="is_disabled_cross_out_publish_rate"
          >Crossout Publish Rate</b-form-checkbox>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'PPOBProduct' }">
            <b-button :disabled="loading || loading_special_rate" class="col-2 mr-3" variant="outline-secondary" size="lg">CANCEL</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading || loading_special_rate"
            @click="post()"
            class="col-2"
            size="lg"
          >
            CREATE
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        type: "",
        bill_type: "",
        provider_id: "",
        provider_product_code: "",
        display_name: {
          en: "",
          id: "",
        },
        description: {
          en: "",
          id: "",
        },
        base_rate: 0,
        publish_rate: 0,
        is_adjustment: false,
        adjustment_type: "",
        adjustment_amount: 0,
        adjustment_as: "",
        special_rate: 0,
        is_cross_out_publish_rate: false,
      },
      optionTypes: [
        { text: "Pulsa", value: 'pulsa' },
        { text: "Data Package", value: 'data_package' },
        { text: "Other", value: 'other' },
      ],
      optionBillTypes: [
        { text: "Pre Paid", value: 'pre_paid' },
        { text: "Post Paid", value: 'post_paid' },
      ],
      optionAdjustmentTypes: [
        { text: "Amount", value: 'amount' },
        { text: "Percentage", value: 'percentage' },
      ],
      optionAdjustmentAs: [
        { text: "Addition", value: 'addition' },
        { text: "Reduction", value: 'reduction' },
        { text: "Fixed Price", value: 'fixed_price' },
      ],
      optionProviders: [],
      other_type: "",
      loading: false,
      loading_special_rate: false,
    };
  },
  computed: {
    special_rate() {
      if (this.item.is_adjustment && this.item.bill_type == 'pre_paid') {
        let self = this;
        if (this.item.publish_rate > 0 && this.item.adjustment_amount > 0 && this.item.adjustment_type != "" && this.item.adjustment_as != "") {
          this.loading_special_rate = true;
          setTimeout(() => {
            const payload = {
              adjustment_type: this.item.adjustment_type,
              adjustment_as: this.item.adjustment_as,
              adjustment_amount: parseInt(this.item.adjustment_amount),
              publish_rate: parseInt(this.item.publish_rate),
            }
            this.$store
              .dispatch("PPOBProductModule/postCalculateSpecial", payload)
              .then((response) => {
                self.item.special_rate = response.data.data.special_rate;
              })
              .catch((error) => {
                this.$swal({
                  type: "error",
                  title: "Oops...",
                  text: error.response.data.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.item.special_rate = 0;
              });
            self.loading_special_rate = false;
          }, 2000);
        }
      }
      return this.item.special_rate;
    },
    is_disabled_cross_out_publish_rate() {
      if (this.item.special_rate > this.item.publish_rate) {
        this.item.is_cross_out_publish_rate = false;
        return true;
      }
      
      return false;
    }
  },
  beforeMount() {
    this.$store
      .dispatch("MasterProviderModule/getMasterProviders")
      .then((response) => {
        this.optionProviders = response.data.data;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.optionProviders = [];
      });
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("bill_type", this.item.bill_type);
          formData.append("provider_id", this.item.provider_id);
          formData.append("provider_product_code", this.item.provider_product_code);
          formData.append("display_name_id", this.item.display_name.id);
          formData.append("display_name_en", this.item.display_name.en);
          formData.append("description_id", this.item.description.id);
          formData.append("description_en", this.item.description.en);
          formData.append("base_rate", this.item.base_rate);
          formData.append("publish_rate", this.item.publish_rate);
          formData.append("is_adjustment", this.item.is_adjustment);
          formData.append("adjustment_type", this.item.adjustment_type);
          formData.append("adjustment_amount", this.item.adjustment_amount);
          formData.append("adjustment_as", this.item.adjustment_as);
          formData.append("special_rate", this.item.special_rate);
          formData.append("is_cross_out_publish_rate", this.item.is_cross_out_publish_rate);
          if (this.item.type === 'other' && this.other_type !== '') {
            let otherType = this.other_type.toLowerCase();
            otherType = otherType.replaceAll(' ', "_");
            formData.append("type", otherType);
          } else {
            formData.append("type", this.item.type);
          }
          if (this.item.special_rate < 0) {
            this.$swal({
                type: "error",
                title: "Oops...",
                text: "Please check special rate value",
                showConfirmButton: false,
                timer: 1500,
              });
            this.loading = false;
            return;
          }
          this.$store
            .dispatch("PPOBProductModule/postPPOBProduct", formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "PPOBProduct" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.data.join(","),
                showConfirmButton: false,
                timer: 3000,
              });
              this.serverError = error.response.data;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    }
  },
};
</script>
<style scoped>
.custom-input-group-append {
  display: inline-block;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #d1d3e2;
  border-left: none;
  vertical-align: middle;
  text-align: center;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  font-size: 1rem;
  border-radius: 0.35rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.custom-input-group-append:hover {
  color: #2c3e50;
  cursor: unset;
}
.custom-input-group-prepend {
  display: inline-block;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #d1d3e2;
  border-right: none;
  vertical-align: middle;
  text-align: center;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  font-size: 1rem;
  border-radius: 0.35rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.custom-input-group-prepend:hover {
  color: #2c3e50;
  cursor: unset;
}
.custom-input-group-prepend.is-invalid {
  border-color: #e74a3b;
}
.custom-input-group-append.is-invalid {
  border-color: #e74a3b;
}
.custom-input-group-prepend.is-valid {
  border-color: #1cc88a;
}
.custom-input-group-append.is-valid {
  border-color: #1cc88a;
}
.custom-disabled-color {
  background-color: #eaecf4;
  border-color: #d1d3e2 !important;
}
</style>